module.exports = __webpack_public_path__ + "static/media/blog-1.29558a69.jpg";